export enum CanaryStatus {
  Canary = 'canary',
  Primary = 'primary',
  Unknown = 'unknown',
}
